"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var apiCalls_1 = require("./apiCalls");
/**
 * Class will contain methods with payment logic
 */
var PaymentsApi = /** @class */ (function () {
    function PaymentsApi() {
        this.charge = function (_a) {
            var request = _a.request, _b = _a.host, host = _b === void 0 ? '' : _b;
            return apiCalls_1.default.charge({ request: request, host: host });
        };
        this.fetchPaymentMethodSettings = function (config, host) { return apiCalls_1.default.fetchPaymentMethodSettings(config, host); };
    }
    return PaymentsApi;
}());
exports.default = new PaymentsApi();
//# sourceMappingURL=paymentsApi.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/paymentsApi.js
// module id = 32
// module chunks = 0 1